import React, { useState } from 'react';
import { Button, Divider, Modal, Popconfirm, Space } from 'antd';
import { EditOutlined, TagOutlined } from '@ant-design/icons';
import { getWorkflowButtonConfig } from './LabWFbuttonConfig';

interface WorkflowButtonsProps {
  wf_actions: string[];
  currentMode: string | null;
  onEditClick?: () => void;
  onActionClick: (action: string) => void;
  onZeroInvoicingClick?: (action: string) => void;
  loading?: boolean;
  disabled?: boolean;
  status?: string | null;
  type?: any | null;
}

const LabWorkflowButtons: React.FC<WorkflowButtonsProps> = ({
  wf_actions,
  currentMode,
  onEditClick,
  onActionClick,
  onZeroInvoicingClick,
  loading = false,
  disabled = false,
  status,
  type,
}) => {
  if (currentMode !== 'view' || !wf_actions || wf_actions.length === 0) {
    return null;
  }

  const renderWorkflowButtons = () => {
    return wf_actions.map((action) => {
      const config = getWorkflowButtonConfig(action);

      if (!config.label && !config.icon) {
        console.log(`Skipping action ${action} - no label or icon`);
        return null;
      }

      if (
        action === 'PENDING_TA_TO_APPROVED' ||
        action === 'PENDING_PA_TO_APPROVED' ||
        action === 'PENDING_VA_TO_APPROVED'
      ) {
        return (
          <React.Fragment key={action}>
            {/* Zero Invoicing Button with Popconfirm */}
            <Popconfirm
              title={
                <span style={{ color: 'black' }}>
                  Are you sure you want to proceed with Zero Invoicing for this item?
                </span>
              }
              onConfirm={() => onZeroInvoicingClick?.(action)}
              okText="Yes"
              cancelText="No"
            >
              <Button
                style={{
                  backgroundColor: '#2c3e91',
                  color: 'white',
                  border: 'none',
                }}
                icon={<TagOutlined />}
                loading={loading}
                disabled={disabled}
                size="small"
              >
                Approve with Zero Invoicing
              </Button>
            </Popconfirm>

            {/* Regular Approve Button */}
            <Button
              type={config.type}
              icon={config.icon}
              loading={loading}
              disabled={disabled}
              onClick={() => onActionClick(action)}
              danger={config.danger}
              size="small"
            >
              {config.label}
            </Button>
          </React.Fragment>
        );
      }

      // Regular button rendering for other actions
      const buttonLabel = config.label || action.replace(/_/g, ' ');

      return (
        <Button
          key={action}
          type={config.type}
          icon={config.icon}
          loading={loading}
          disabled={disabled}
          onClick={() => onActionClick(action)}
          danger={config.danger}
          size="small"
        >
          {buttonLabel}
        </Button>
      );
    });
  };

  return (
    <div style={{ marginBottom: 16, textAlign: 'left' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Space wrap>
          {currentMode === 'view' &&
            type !== 'result' &&
            (status === 'PENDING_TA' || status === 'PENDING_MA' || status === 'PENDING_IA') && (
              <Button type="default" icon={<EditOutlined />} onClick={onEditClick} disabled={disabled} size="small">
                Edit
              </Button>
            )}

          {/* Workflow action buttons */}
          {wf_actions && wf_actions.length > 0 && renderWorkflowButtons()}
        </Space>
      </div>

      {(currentMode === 'view' || (wf_actions && wf_actions.length > 0)) && <Divider style={{ margin: '16px 0' }} />}
    </div>
  );
};

export default LabWorkflowButtons;
